// extracted by mini-css-extract-plugin
module.exports = {"title":"IndicesSteps_title__1XlRI","list":"IndicesSteps_list__G3_yq"};